<template>
  <alzata-dialog
    ref="vaccineModal"
    :title="vaccine?.id ? 'Edit Vaccination' : 'Create Vaccination'"
  >
    <div class="row g-2">
      <div class="col-12">
        <label for="name" class="small">Name *</label>
        <input
          id="name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          placeholder="Name"
          v-model="name"
        />
        <div v-if="errors.name" class="invalid-feedback">
          Name is required.
        </div>

        <label for="description" class="small">Description</label>
        <textarea
          rows="5"
          id="description"
          type="text"
          class="form-control"
          placeholder="Description"
          v-model="description"
        ></textarea>

        <label for="administrationDate" class="small"
          >Administration Date *</label
        >
        <input class="form-control"
                :class="{ 'is-invalid': errors.admin }"
                v-model="administrationDate" />
        <div v-if="errors.admin" class="invalid-feedback">
          Administration date is required in the format (MM/DD/YYYY).
        </div>

        <label for="expirationDate" class="small">Expiration Date *</label>

        <input class="form-control"
                :class="{ 'is-invalid': errors.expiry }" v-model="expirationDate" />
        <div v-if="errors.expiry" class="invalid-feedback">
          Expiration date is required in the format (MM/DD/YYYY).
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="hide">Cancel</button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>
import { DateTime } from "luxon";
export default {
  name: "EditVaccinationDialog",
  emits: ["save"],
  mounted() {},
  data() {
    return {
      vaccine: null,
      name: null,
      description: null,
      administrationDate: null,
      expirationDate: null,
      errors: {
        name: false,
        admin: false,
        expiry: false,
      },
    };
  },
  methods: {
    clearValidation() {
      this.errors.name = false;
      this.errors.admin = false;
      this.errors.expiry = false;
    },
    show(vaccine) {
      this.vaccine = vaccine;
      this.name = vaccine.name;
      this.description = vaccine.description;
      this.administrationDate = this.formatDate(vaccine.administrationDate);
      this.expirationDate = this.formatDate(vaccine.expirationDate);

      this.clearValidation();

      this.$refs.vaccineModal.show();
    },
    hide() {
      this.$refs.vaccineModal.hide();
    },
    formatDate(dateString) {
      if (!dateString) return null;
      const date = DateTime.fromISO(dateString);
      const formatted = date.toLocaleString(DateTime.DATE_SHORT);
      return formatted;
    },
    formatDateRelative(dateString) {
      const date = DateTime.fromISO(dateString);
      const relative = date.toRelative();
      return relative;
    },
    save() {
      this.errors.name = !this.name;

      const admin = DateTime.fromFormat(this.administrationDate || "", "M/d/yyyy");
      const isAdminValid = admin.isValid;
      this.errors.admin = !isAdminValid;

      const expiry = DateTime.fromFormat(this.expirationDate || "", "M/d/yyyy");
      const isExpiryValid = expiry.isValid;
      this.errors.expiry = !isExpiryValid;

      if (this.errors.name || this.errors.admin || this.errors.expiry) {
        return;
      }

      this.$emit("save", {
        id: this.vaccine.id,
        name: this.name,
        description: this.description,
        administrationDate: this.administrationDate,
        expirationDate: this.expirationDate,
      });
    },
  },
};
</script>
